import { CustomerOrderBase } from '../contracts/customer-order.js';
import { EventTicketOrder } from '../models/serializable/event-ticket-order.js';
import { OnlineEventTicketOrder } from '../models/serializable/online-event-ticket-order.js';
import { OnlineProductOrder } from '../models/serializable/online-product-order.js';
import { Price } from '../models/serializable/price.js';

export abstract class DonationHelper {
  static hasDonation(order: CustomerOrderBase): boolean {
    if(OnlineEventTicketOrder.assertType(order)) {
      return order.donation != null;
    }
    if(OnlineProductOrder.assertType(order)) {
      return order.donation != null;
    }
    if(EventTicketOrder.assertType(order)) {
      return order.donation != null;
    }

    return false;
  }

  static getDonationAmount(order: CustomerOrderBase): Price | null {
    if(OnlineEventTicketOrder.assertType(order)) {
      return order.donation;
    }
    if(OnlineProductOrder.assertType(order)) {
      return order.donation;
    }
    if(EventTicketOrder.assertType(order)) {
      return order.donation;
    }

    return null;
  }
}
